
import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { State } from 'vuex-class'
import moment from 'moment'

import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppDialog from '@/components/AppDialog.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppRefreshAndExport from '@/components/AppRefreshAndExport.vue'
import AppSearchBtn from '@/components/AppSearchBtn.vue'
import AppSimpleSelector from '@/components/AppSimpleSelector.vue'
import AppSimpleTextField from '@/components/AppSimpleTextField.vue'
import AppSimpleDatePicker from '@/components/AppSimpleDatePicker.vue'
import AppSimpleSearchSelector from '@/components/AppSimpleSearchSelector.vue'
import AppRadio from '@/components/AppRadio.vue'
import AppLightModal from '@/components/AppLightModal.vue'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { utcDateTimeToLocal, formatWeixinDate } from '@/utils/dateTime'
import ListPage from '@/mixins/list-page'
import AppSimpleDistrictSelector from '@/components/AppSimpleDistrictSelector.vue'
import { findOrders, findAllPeriod, exportOrdersList, exportOrdersStatList } from './gql'
import { OrdersOrderBy, OrderModel, OrderStatus } from '@/interfaces/order'
import { statusCodes, statusOptions, OrderStatusText, refundOptions, refundKey, RefundWayText } from '@/helpers/order'
import { TypedGqlError } from '@/interfaces/error'
import { createRefund, cancelRefund } from '../RefundList/gql'
import AppTextarea from '@/components/AppTextarea.vue'
import AuthFilter from '@/mixins/auth-filter'
import { findDealers } from '@/views/DealerList/gql'
import { auditStatusText } from '@/helpers/audit'
import { formatCurrency } from '@/utils/currency'
import { findSchools } from '../SchoolList/gql'
import { AreaModel } from '@/interfaces/area'
import { SchoolModel } from '@/interfaces/school'
import { downloadBase64 } from '@/helpers/base64-to-file'
import { dispatchUpdateIfNewOrders } from '../../store/dispatches'

@Component({
  components: {
    AppBreadcrumbs,
    AppCheckbox,
    AppRefreshAndExport,
    AppDialog,
    AppSimpleTextField,
    AppSimpleSelector,
    AppDatePicker,
    AppSearchBtn,
    AppSelector,
    AppTextField,
    AppSimpleDatePicker,
    AppLightModal,
    AppSimpleDistrictSelector,
    AppTextarea,
    AppRadio,
    AppSimpleSearchSelector
  }
})
export default class OrderList extends mixins(ListPage, AuthFilter) {
  @State(state => state.page.OrderList) cache!: string
  breadcrumbs: Breadcrumb[] = [
    {
      text: '订单管理'
    }, {
      text: '订单'
    }
  ]

  options = {
    sortBy: ['createdAt'],
    page: 1,
    itemsPerPage: 10,
    sortDesc: [true]
  }

  utcDateTimeToLocal = utcDateTimeToLocal
  formatWeixinDate = formatWeixinDate
  formatCurrency = formatCurrency
  OrderStatusText = OrderStatusText
  filter: any = {
    area: null,
    orderNumber: null,
    transactionNumber: null,
    period_EQ: -1,
    dealerId: {
      id: null,
      label: ''
    },
    orderTimeStart: null,
    orderTimeEnd: null,
    phone: null,
    realname: null,
    studentName: null,
    schoolName: null,
    statusIndex: -1,
    schoolIndex: -1,
    createdAt_GTE_DATE: moment().subtract(1, 'M').format('YYYY-MM-DD'),
    createdAt_LTE_DATE: moment().format('YYYY-MM-DD')
  }

  totalNum = 0
  totalAmount = ''
  loading = false

  headers = [
    { text: '操作', value: 'operation', sortable: false, width: 100 },
    { text: '退款方式', value: 'refund.refundWay', sortable: false, width: 140 },
    { text: '审核状态', value: 'refund.auditStatus', sortable: false, width: 120 },
    { text: '订单状态', value: 'status', width: 150 },
    { text: '征订周期', value: 'period', sortable: false, width: 130 },
    { text: '经销商', value: 'dealer.realname', sortable: false, width: 120 },
    { text: '订单编号', value: 'orderNumber', width: 200 },
    { text: '订单流水编号', value: 'transactionNumber', width: 200 },
    { text: '商品/单价', value: 'items' },
    { text: '买家', value: 'address', width: 140 },
    { text: '支付', value: 'payWay', sortable: false, width: 90 },
    { text: '价格', value: 'totalPrice', width: 80 },
    { text: '下单时间', value: 'createdAt', width: 120 },
    { text: '付款时间', value: 'timeEnd', width: 120 },
    { text: '备注', value: 'buyerMessage', sortable: false, width: 80 }
  ]

  windowSize = {
    w: 0,
    h: 0
  }

  statusCodes = statusCodes()
  statusOptions = statusOptions()
  refundDialog = {
    show: false,
    title: '创建退款单',
    disable: false,
    confirmText: '创建退款单'
  }

  // 退款方式
  refundInput: any = {}
  refundTypeDialog = {
    show: false,
    title: '选择退款方式'
  }

  refundOptions = refundOptions()
  refundKey = refundKey()
  RefundWayText = RefundWayText

  // 审核状态
  AuditStatusText = auditStatusText

  refundWithdrawDialog = {
    show: false,
    text: '确认撤销退款?'
  }

  periodOptions = []
  dealerOptions: any[] = []

  OrderStatus = OrderStatus
  actionsHeight = 51
  orders: OrderModel[] = []
  orderInfo: OrderModel | null = null
  schools: SchoolModel[] = []
  schoolOptions: string[] = []

  confirmForm = false

  delayClock: any = null

  get rightDateLimit () {
    return {
      max: moment().format('YYYY-MM-DD'),
      min: this.filter.createdAt_GTE_DATE ? moment(this.filter.createdAt_GTE_DATE).format('YYYY-MM-DD') : null
    }
  }

  usingStatus (status: string) {
    return {
      'u-tag-blue': status === this.OrderStatus.TO_BE_PAID,
      'u-tag-red': status === this.OrderStatus.ERROR,
      'u-tag-orange': status === this.OrderStatus.REFUNDING,
      'u-tag-green': status === this.OrderStatus.SUCCESS,
      'u-tag-dark': status === this.OrderStatus.CLOSED,
      'u-tag-grey': status === this.OrderStatus.REFUND,
      'u-tag-yellow': status === this.OrderStatus.PAID
    }
  }

  @Watch('options', { deep: true })
  onOptionsChanged () {
    this.getOrders()
  }

  @Watch('filter.area', { deep: true })
  onAreaChanged (val: AreaModel) {
    if (this.delayClock) {
      clearTimeout(this.delayClock)
      this.delayClock = null
    }
    if (!val) {
      this.schoolOptions = []
      return
    }
    this.delayClock = setTimeout(async () => {
      this.schoolOptions = await this.querySchoolsRequest(val.id) ?? []
    }, 2000)
  }

  @Watch('filter.createdAt_GTE_DATE', { deep: true })
  onDateRangeChanged (startDate: string) {
    const { createdAt_LTE_DATE: endDate } = this.filter
    const startMmt = moment(startDate)
    const endMmt = moment(endDate)

    if (!startDate) {
      return
    }

    if (startMmt.isAfter(endMmt)) {
      this.filter.createdAt_LTE_DATE = null
    }
  }

  @Watch('filter.createdAt_LTE_DATE', { deep: true })
  onDateRangeChanged2 (endDate: string) {
    const { createdAt_GTE_DATE: startDate } = this.filter
    const startMmt = moment(startDate)
    const endMmt = moment(endDate)

    if (!endDate) {
      return
    }

    if (startMmt.isAfter(endMmt)) {
      this.filter.createdAt_GTE_DATE = null
      return
    }

    if (startMmt.isBefore(endMmt.subtract(1, 'M'))) {
      this.filter.createdAt_GTE_DATE = endMmt.subtract(1, 'M').format('YYYY-MM-DD')
    }
  }

  mounted () {
    if (this.getRole() === 'dealer') {
      this.headers.shift()
    }
    this.onResize()
    this.restorePage(this.cache)
    this.getOrders()
    this.getPeriodOptions()
    this.getDealerOptions()
  }

  // 获取订单列表
  async getOrders () {
    const { sortBy, page, itemsPerPage, sortDesc } = this.options
    const {
      orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, schoolIndex, createdAt_GTE_DATE,
      createdAt_LTE_DATE, area, realname
    } = this.filter
    const by = OrdersOrderBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false

    this.loading = true
    const order = { by, asc }
    const paging = {
      skip: itemsPerPage * (page - 1),
      take: itemsPerPage
    }
    const where = {
      orderNumber: orderNumber || null,
      status_EQ: this.statusCodes[statusIndex] || null,
      period_EQ: this.periodOptions[period_EQ] || null,
      transactionNumber: transactionNumber,
      phone: phone,
      realname: realname || null,
      dealerId: dealerId ? dealerId.id : null,
      schoolId: schoolIndex >= 0 ? this.schools[schoolIndex].id : null,
      createdAt_GTE_DATE: createdAt_GTE_DATE || null,
      createdAt_LTE_DATE: createdAt_LTE_DATE || null,
      mailingAddress: area ? (area as any).mergerName : null
    }
    const result = await this.queryOrdersRequest(order, paging, where)

    if (result) {
      this.orders = result.orders

      this.totalNum = result.paging.totalCount
      this.totalAmount = result.totalAmount
    }
    this.loading = false
    this.storePage()
    dispatchUpdateIfNewOrders({
      order: false
    })
  }

  // 获取征订周期option
  async getPeriodOptions () {
    try {
      const result = await this.$apollo.query({
        query: findAllPeriod
      })
      if (result) {
        this.periodOptions = result.data.findAllUsedPeriodSettings
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 获取经销商option
  async getDealerOptions (query?: { take: number; model: string }) {
    const where = query && query.model ? { realname: query.model } : null
    const take = query && query.take ? query.take : 20
    try {
      const result = await this.$apollo.query({
        query: findDealers,
        variables: {
          order: null,
          paging: {
            skip: 0,
            take
          },
          where
        }
      })
      if (result.data.findDealers) {
        this.dealerOptions = result.data.findDealers.dealers.map((option: any) => {
          return {
            id: option.id,
            label: option.realname
          }
        })
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async querySchoolsRequest (areaId: number) {
    try {
      const result = await this.$apollo.query({
        query: findSchools,
        variables: {
          where: {
            areaId
          }
        }
      })
      this.schools = result.data.findSchools.schools
      return this.schools.map(school => school.name)
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async queryOrdersRequest (order: any, paging: any, where: any) {
    try {
      const result = await this.$apollo.query({
        query: findOrders,
        variables: {
          order,
          paging,
          where
        }
      })
      return result.data.findOrders
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 详情
  routeToDetail (item: OrderModel) {
    this.$router.push({
      name: 'OrderDetail',
      params: {
        id: item.id + '',
        orderNumber: item.orderNumber
      }
    })
  }

  filterQuerySubmit () {
    this.getOrders()
  }

  refreshList () {
    this.filter = {
      area: null,
      orderNumber: null,
      transactionNumber: null,
      orderTimeStart: null,
      orderTimeEnd: null,
      phone: null,
      realname: null,
      studentName: null,
      schoolName: null,
      statusIndex: -1,
      period_EQ: -1,
      dealerId: {
        id: null,
        label: ''
      },
      schoolIndex: -1,
      createdAt_GTE_DATE: null,
      createdAt_LTE_DATE: null
    }
    this.getOrders()
  }

  async exportSchoolOrders () {
    showNotification({
      msg: '即将开始下载...',
      type: SnackType.Info
    })
    const { sortBy, sortDesc } = this.options
    const {
      orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, schoolIndex, createdAt_GTE_DATE,
      createdAt_LTE_DATE, area, realname
    } = this.filter
    const by = OrdersOrderBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false
    this.loading = true
    const order = { by, asc }
    const where = {
      orderNumber: orderNumber || null,
      status_EQ: this.statusCodes[statusIndex] || null,
      period_EQ: this.periodOptions[period_EQ] || null,
      transactionNumber: transactionNumber,
      phone: phone,
      realname: realname || null,
      dealerId: dealerId ? dealerId.id : null,
      schoolId: this.schools[schoolIndex] ? this.schools[schoolIndex].id : null,
      createdAt_GTE_DATE: createdAt_GTE_DATE || null,
      createdAt_LTE_DATE: createdAt_LTE_DATE || null,
      mailingAddress: area ? (area as any).mergerName : null
    }
    try {
      const result = await this.$apollo.query({
        query: exportOrdersList,
        variables: {
          order,
          where
        }
      })
      if (result.data) {
        const { fileName, contentB64 } = result.data.exportOrdersList
        downloadBase64(contentB64, fileName)
      }
      this.loading = false
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async exportSchoolOrdersStat () {
    if (this.filter.schoolIndex === -1) {
      showNotification({
        msg: '请先选择学校',
        type: SnackType.Error
      })
      return
    }
    showNotification({
      msg: '即将开始下载...',
      type: SnackType.Info
    })
    const { sortBy, sortDesc } = this.options
    const {
      orderNumber, statusIndex, period_EQ, transactionNumber, phone, dealerId, schoolIndex, createdAt_GTE_DATE,
      createdAt_LTE_DATE
    } = this.filter
    const by = OrdersOrderBy[sortBy[0] || 'createdAt']
    const asc = !sortDesc[0] || false
    this.loading = true
    const order = { by, asc }
    const where = {
      orderNumber: orderNumber || null,
      status_EQ: this.statusCodes[statusIndex] || null,
      period_EQ: this.periodOptions[period_EQ] || null,
      transactionNumber: transactionNumber,
      phone: phone,
      dealerId: dealerId ? dealerId.id : null,
      schoolId: this.schools[schoolIndex].id,
      createdAt_GTE_DATE: createdAt_GTE_DATE || null,
      createdAt_LTE_DATE: createdAt_LTE_DATE || null
    }
    try {
      const result = await this.$apollo.query({
        query: exportOrdersStatList,
        variables: {
          order,
          where
        }
      })
      if (result.data) {
        const { fileName, contentB64 } = result.data.exportOrdersStatList
        downloadBase64(contentB64, fileName)
      }
      this.loading = false
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  refundHandler (item: OrderModel) {
    this.orderInfo = JSON.parse(JSON.stringify(item)) as OrderModel
    this.orderInfo.totalPrice = Number(this.formatCurrency(this.orderInfo.totalPrice))
    this.refundInput = { }
    this.refundTypeDialog.show = true
  }

  refundTypeConfirm () {
    if (typeof this.refundInput.refundType !== 'undefined') {
      this.refundDialog.show = true
      this.refundTypeDialog.show = false
    } else {
      showNotification({
        msg: '请选择退款类型!',
        type: SnackType.Info
      })
    }
  }

  refundTypeCancel () {
    this.refundTypeDialog.show = false
  }

  refundWithdrawHandler (item: OrderModel) {
    this.orderInfo = item
    this.refundWithdrawDialog.show = true
  }

  refundWithdrawCancel () {
    this.refundWithdrawDialog.show = false
  }

  async refundWithdrawConfirm () {
    try {
      const result = await this.$apollo.mutate({
        mutation: cancelRefund,
        variables: {
          orderId: this.orderInfo?.id
        }
      })
      if (result) {
        this.refundWithdrawDialog.show = false
        showNotification({
          msg: '撤销退款成功',
          type: SnackType.Success
        })
        this.getOrders()
      }
    } catch (e) {
      this.confirmForm = false
      this.refundDialog.show = false
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  // 创建退款单
  async refundFormConfirm () {
    this.confirmForm = true
    const { description, refundType } = this.refundInput

    try {
      const result = await this.$apollo.mutate({
        mutation: createRefund,
        variables: {
          orderId: this.orderInfo?.id,
          description,
          refundWay: this.refundKey[refundType as number]
        }
      })

      if (result) {
        this.confirmForm = false
        this.refundDialog.show = false
        showNotification({
          msg: '创建退款单成功',
          type: SnackType.Success
        })
        this.refundInput = {}
        this.getOrders()
      }
    } catch (e) {
      this.confirmForm = false
      this.refundDialog.show = false
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  refundFormCancel () {
    this.refundInput = {}
  }

  onResize () {
    this.windowSize = { w: window.innerWidth, h: window.innerHeight }
    const actionDom = this.$refs.actions as Vue & {
      clientHeight: number;
    }
    this.actionsHeight = actionDom.clientHeight
  }
}
